export default __webpack_public_path__ + "static/media/category_34.5ebb07ac.png";